import { render, staticRenderFns } from "./template.vue?vue&type=template&id=71bd4359&scoped=true&"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&lang=css&"
import style1 from "./template.vue?vue&type=style&index=1&id=71bd4359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd4359",
  null
  
)

export default component.exports